import { render, staticRenderFns } from "./adminLogin.vue?vue&type=template&id=9a0412c6&scoped=true"
import script from "./adminLogin.vue?vue&type=script&lang=js"
export * from "./adminLogin.vue?vue&type=script&lang=js"
import style0 from "./adminLogin.vue?vue&type=style&index=0&id=9a0412c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0412c6",
  null
  
)

export default component.exports